import { BaseEntityUtils } from './BaseEntityUtils';
import { VehicleAttributeType } from './../data/models/vehicle-attribute-type.model';
import { Vehicle, VehicleAttribute } from '../data/models/vehicle.model';
import validationUtils from './validationUtils';
import { VehicleType } from '../data/models/vehicle-type.model';
import { VehicleColor } from '../data/models/vehicle-color.model';
import { DateTime } from 'luxon';

class VehicleUtils extends BaseEntityUtils {
  public getDefaults(
    vehicle: Vehicle | null | undefined,
    attributeTypes: VehicleAttributeType[],
  ): any {
    const attributes: any = {};
    attributeTypes.forEach((attrType) => {
      const attrName = 'attr-' + attrType.vehicleAttributeTypeID;
      const attr = vehicle?.vehicleAttributes?.find(
        (a) => a.vehicleAttributeTypeID === attrType.vehicleAttributeTypeID,
      );
      attributes[attrName] =
        attr?.vehicleAttributeState == 'active' && !!attr?.quantity
          ? attr.quantity
          : 0;
    });
    return {
      LicensePlate: this.getDefaultString(vehicle?.licensePlate),
      LicenseStateCode: this.getDefaultString(
        vehicle?.licensePlateIssuedInStateCode,
      ),
      RegistrationExpiresOn: this.getDefaultDate(
        vehicle?.registrationExpiresOn,
      ),
      VehicleVIN: this.getDefaultString(vehicle?.vehicleVIN),
      VehicleTypeID: this.getDefaultNumber(vehicle?.vehicleTypeID),
      VehicleMake: this.getDefaultString(vehicle?.vehicleMake),
      VehicleModel: this.getDefaultString(vehicle?.vehicleModel),
      VehicleYear: this.getDefaultNumber(vehicle?.vehicleYear),
      VehicleColorID: this.getDefaultString(vehicle?.vehicleColor),
      IsClearToTransport: this.getDefaultBoolean(vehicle?.isClearToTransport),
      IsInternal: this.getDefaultBoolean(vehicle?.isInternal),
      IsActive: vehicle ? vehicle.vehicleState === 'active' : true,
      ...attributes,
    };
  }

  public getVehicleFromFormData(
    providerId: number,
    id: number | undefined,
    formData: any,
    attributeTypes: VehicleAttributeType[],
  ): Vehicle {
    const attributes: VehicleAttribute[] = [];
    for (const attrType of attributeTypes) {
      const val = Number.parseInt(
        `attr-${attrType.vehicleAttributeTypeID}` in formData
          ? formData[`attr-${attrType.vehicleAttributeTypeID}`]
          : '0',
        10,
      );
      attributes.push({
        vehicleID: id,
        vehicleAttributeTypeID: attrType.vehicleAttributeTypeID,
        quantity: val,
        vehicleAttributeState: 'active',
      });
    }
    return {
      vehicleID: id,
      transportationProviderID: providerId,
      licensePlate: formData.LicensePlate,
      licensePlateIssuedInStateCode: formData.LicenseStateCode,
      registrationExpiresOn: DateTime.fromISO(formData.RegistrationExpiresOn)
        .setZone('utc')
        .toFormat(validationUtils.validDateFormat()),
      vehicleVIN: formData.VehicleVIN,
      vehicleTypeID: formData.VehicleTypeID,
      vehicleMake: formData.VehicleMake,
      vehicleModel: formData.VehicleModel,
      vehicleYear: formData.VehicleYear,
      vehicleColor: formData.VehicleColorID,
      isClearToTransport: formData.IsClearToTransport,
      isInternal: formData.IsInternal,
      vehicleAttributes: attributes,
      vehicleState: formData.IsActive ? 'active' : 'inactive',
    };
  }

  public getVehicleTypeName(
    vehicleTypes: VehicleType[],
    typeId: number | undefined,
  ) {
    const type = vehicleTypes.find((t) => t.vehicleTypeID === typeId);
    return type ? type.vehicleTypeName : '';
  }

  public getVehicleColor(
    vehicleColors: VehicleColor[],
    colorId: number | undefined,
  ) {
    const type = vehicleColors.find((t) => t.vehicleColorID === colorId);
    return type ? type.vehicleColorName : '';
  }
}

const vehicleUtils = new VehicleUtils();

export default vehicleUtils;
